<template>
  <div>
    <transition name="fade">
      <div class="pu_dark" v-show="$store.getters.modal.clear"></div>
    </transition>
    <transition name="slide">
      <div class="pu_basket_clear popup_click_hide" v-show="$store.getters.modal.clear">
        <div class="pu_bc_btn">
          <a class="fbb_btn pu_bc_btn_clear" @click="clearBasket">{{ text('clear_basket_clear') }}</a>
          <a @click="close" class="fbb_btn pu_bc_next">{{ text('clear_basket_cancel') }}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {CLEAR_BASKET} from '@/store/actions.type'
  import {SET_MODAL} from '@/store/mutations.type'

  export default {
    name: 'BasketClearConfirm',
    data() {
      return {}
    },
    watch: {},
    methods: {
      clearBasket() {
        this.$store.dispatch(CLEAR_BASKET)
        this.close()
      },
      close() {
        this.$store.commit(SET_MODAL, {modal: 'clear', status: false})
      }
    }
  }
</script>

<style scoped>


  .pu_basket_clear {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9999998;
  }

  .pu_bc_btn {
    position: absolute;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
    bottom: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .pu_bc_btn .fbb_btn + .fbb_btn {
    margin-top: 8px;
  }

  .pu_bc_btn_clear {
    background: #FDF0F1;
    color: #EB4253;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .pu_bc_next {
    background: #FFFFFF;
    color: #999;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
</style>
